import React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '../../../Box';
import { ListItemIcon, ListItemText } from '../../../List';
import MenuItem from '../../../MenuItem/MenuItem';
import Typography from '../../../Typography';
import Avatar from '../../../Avatar';
const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&.MuiListItemIcon-root': {
        minWidth: 0,
        padding: 0,
        margin: 0
    },
    '& .MuiSvgIcon-root': {
        fill: theme.palette.icon.interactive.neutral.color.default,
        width: theme.palette.icon.size.small,
        height: theme.palette.icon.size.small,
        fontSize: theme.palette.icon.size.small
    }
}));
const StyledAvatarbox = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: theme.palette.space.container.dense,
    overflowWrap: 'anywhere',
    marginBottom: theme.palette.space.container.spacious
}));
export const ProfileMenu = ({ name, email, initials, menuItems, footer }) => {
    const theme = useTheme();
    const handleKeyDown = (event, item) => {
        if (event.key === 'Enter' || event.key === ' ') {
            if (item.disabled) {
                return;
            }
            if (item.onClick) {
                item.onClick();
            }
        }
    };
    return (React.createElement(Box, { display: "flex", flexDirection: "column", width: "100%", height: "100%", "data-testid": "profile-menu", role: "menu", "aria-label": "Profile menu" },
        React.createElement(Box, { "data-testid": "profile-menu-contents" },
            React.createElement(StyledAvatarbox, null,
                React.createElement(Avatar, { bdsType: "staticEmphasis", bdsSize: "xxlarge", "aria-hidden": "true" }, initials),
                React.createElement(Box, { display: "flex", flexDirection: "column", gap: "2px", flexGrow: 1 },
                    name && (React.createElement(Typography, { variant: "h4", sx: { fontWeight: theme.typography.fontWeightBold } }, name)),
                    email && React.createElement(Typography, { variant: "body1" }, email))),
            React.createElement(Box, { display: "flex", flexDirection: "column", gap: theme.palette.space.container.dense, role: "menu", "aria-label": "Profile menu items" }, menuItems &&
                menuItems.map((item, index) => {
                    const menuItemContent = (React.createElement(MenuItem, { key: `${item.name}-${index}`, onClick: item.onClick, disabled: item.disabled, onKeyDown: e => handleKeyDown(e, item), role: "menuitem", 
                        /**
                         * The tabIndex is set to -1 for items with href to prevent them from being focusable
                         * Otherwise focus will be set in the href link
                         */
                        tabIndex: item.href ? -1 : 0, sx: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: theme.palette.space.container.dense,
                            textDecoration: 'none',
                            color: 'inherit'
                        } },
                        item.icon && React.createElement(StyledListItemIcon, { "aria-hidden": "true" }, item.icon),
                        React.createElement(ListItemText, null, item.name),
                        item.endIcon && React.createElement(StyledListItemIcon, { "aria-hidden": "true" }, item.endIcon)));
                    if (item.href) {
                        return (React.createElement(Box, { component: "a", tabIndex: 0, key: item.name, href: item.disabled ? undefined : item.href, target: item.openInNewTab && !item.disabled ? '_blank' : undefined, rel: item.openInNewTab && !item.disabled ? 'noopener noreferrer' : undefined, sx: {
                                textDecoration: 'none',
                                '&:focus-visible': {
                                    backgroundColor: theme.palette.menuItem.background.focus,
                                    border: `${theme.palette.menuItem.border.width} solid ${theme.palette.menuItem.border.focus} !important`,
                                    color: theme.palette.menuItem.text.focus,
                                    outline: 'none'
                                }
                            }, onClick: e => {
                                if (!item.disabled && item.onClick) {
                                    item.onClick();
                                }
                            } }, menuItemContent));
                    }
                    return menuItemContent;
                }))),
        footer && (React.createElement(Box, { flexDirection: "column", display: "flex", marginTop: "auto", "data-testid": "profile-menu-footer", gap: "2px", role: "contentinfo", "aria-label": "Profile menu footer" },
            footer.serial && (React.createElement(Typography, { variant: "caption" },
                footer.serialText || 'Serial',
                " ",
                footer.serial)),
            footer.version && (React.createElement(Typography, { variant: "caption" },
                footer.versionText || 'Version',
                " ",
                footer.version)),
            footer.expirationDate && (React.createElement(Typography, { variant: "caption" },
                footer.expirationDateText || 'Exp date',
                " ",
                footer.expirationDate))))));
};
//# sourceMappingURL=ProfileMenu.js.map